import request from '../utils/request';
//获取职业班级
export function getClassList(data) {
  return request({
    url: '/wap/class/getClassList.html',
    method: 'post',
    data
  })
}

//获取数据
export function toNewIndex(data) {
  return request({
    url: '/wap/class/toIndex.html',
    method: 'post',
    data
  })
}

//获取数据
export function toCode(data) {
  return request({
    url: '/class/toCode.html',
    method: 'post',
    data
  })
}
//公告列表
export function toInfoMessage(data) {
  return request({
    url: '/wap/info/toInfoMessage.html',
    method: 'post',
  data
  })
}
//公告详情

export function toInfoMessageDetail(data) {
  return request({
    url: '/wap/info/toInfoMessageDetail.html',
    method: 'get',
  params:data
  })
}
//轮播图详情

export function tofindPictureDetail(data) {
  return request({
    url: '/wap/info/tofindPictureDetail.html',
    method: 'get',
  params:data
  })
}
//资源库视频学习
export function toZykStudy(data) {
  return request({
    url: '/wab/lib/toZykStudy.do',
    method: 'post',
    data
  })
}
//邀请新人链接
export function getShareUrl(data) {
  return request({
    url: '/wap/tyUser/getShareUrl',
    method: 'post',
    data
  });
}

